const isValidInput = (customerSsid: string, customerName: string): boolean => {
    if (customerSsid.length !== 11 || Number.isNaN(customerSsid)) return false;
    return customerName.length >= 1;
};

export default isValidInput;
